module.exports = __webpack_public_path__ + "img/arrow-right.b7cdde7f.svg";